/**
 * Created by iza on 04.12.2017.
 */
var pager = function pager(pagination, options) {
  var type = options.hash.type || 'middle';
  var ret = '';
  var pageCount = Number(pagination.pageCount);
  var page = Number(pagination.page);
  var limit;
  if (options.hash.limit) limit = +options.hash.limit; //page pageCount

  var newContext = {};

  switch (type) {
    case 'middle':
      if (typeof limit === 'number') {
        var i = 0;
        var leftCount = Math.ceil(limit / 2) - 1;
        var rightCount = limit - leftCount - 1;
        if (page + rightCount > pageCount) leftCount = limit - (pageCount - page) - 1;
        if (page - leftCount < 1) leftCount = page - 1;
        var start = page - leftCount;

        while (i < limit && i < pageCount) {
          newContext = {
            n: start
          };
          if (start === page) newContext.active = true;
          ret = ret + options.fn(newContext);
          start++;
          i++;
        }
      } else {
        for (var i = 1; i <= pageCount; i++) {
          newContext = {
            n: i
          };
          if (i === page) newContext.active = true;
          ret = ret + options.fn(newContext);
        }
      }

      break;

    case 'previous':
      if (page === 1) {
        newContext = {
          disabled: true,
          n: 1
        };
      } else {
        newContext = {
          n: page - 1
        };
      }

      ret = ret + options.fn(newContext);
      break;

    case 'next':
      newContext = {};

      if (page === pageCount) {
        newContext = {
          disabled: true,
          n: pageCount
        };
      } else {
        newContext = {
          n: page + 1
        };
      }

      ret = ret + options.fn(newContext);
      break;

    case 'first':
      if (page === 1) {
        newContext = {
          disabled: true,
          n: 1
        };
      } else {
        newContext = {
          n: 1
        };
      }

      ret = ret + options.fn(newContext);
      break;

    case 'last':
      if (page === pageCount) {
        newContext = {
          disabled: true,
          n: pageCount
        };
      } else {
        newContext = {
          n: pageCount
        };
      }

      ret = ret + options.fn(newContext);
      break;
  }

  return ret;
};

var renderTemplate = function renderTemplate(data, source, replace, current, renderView, pagerData, orgAdmin, currentTab) {
  var _self = this;

  _self.data = data;
  var handlebarsevent = new CustomEvent('handlebars-trigger');
  _self.source = document.getElementById(source).innerHTML;

  if ($('#pager').length) {
    _self.pager = document.getElementById('pager').innerHTML;
  }

  _self.initHelper = function () {
    Handlebars.registerHelper('paginate', pager);
    Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
      return arg1 == arg2 ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper("formatDate", function (datetime) {
      if (moment) {
        return moment(datetime).format(' M/DD/YYYY HH:mm:ss A');
      } else {
        return datetime;
      }
    });
    Handlebars.registerHelper("formatOnlyDate", function (datetime) {
      if (moment) {
        return moment(datetime).format(' M/DD/YYYY');
      } else {
        return datetime;
      }
    });
    Handlebars.registerHelper("percent", function (arg1, arg2) {
      var data = Math.round(arg1 / arg2 * 100 * Math.pow(10, 2)) / Math.pow(10, 2);

      if (data != null) {
        var lastone = data.toString().split('').pop();

        if (lastone != '.') {
          data = parseFloat(data);
        }
      }

      return data;
    });
  };

  _self.render = function () {
    _self.initHelper();

    var template = Handlebars.compile(_self.source),
        pagerTemplate,
        render;

    if (_self.pager && _self.pager.length) {
      pagerTemplate = Handlebars.compile(_self.pager);
    }

    if (renderView && renderView.length) {
      render = renderView;
    } else if (current) {
      if (orgAdmin) {
        render = currentTab.find('.tab-content.active').find('[data-render]');
      } else {
        render = $('.tab-content.active').find('[data-render]');
      }
    } else if (orgAdmin) {
      render = currentTab.find('[data-render]');
    } else {
      render = $('[data-render]');
    }

    $.each(render, function () {
      var obj = $(this).attr('render-data'),
          html,
          current = $(this).attr('data-current');

      if (obj && obj.length) {
        html = template($.extend({}, _self.data, JSON.parse(obj)));

        if (pagerData && _self.pager && _self.pager.length) {
          _self.pushTemplate($(this), html, pagerTemplate($.extend({}, pagerData, {
            pager: pagerData.pagination.pageCount
          })));
        } else {
          _self.pushTemplate($(this), html);
        }
      } else {
        html = template(data);

        if (pagerData && _self.pager && _self.pager.length) {
          _self.pushTemplate($(this), html, pagerTemplate($.extend({}, pagerData, {
            pager: pagerData.pagination.pageCount
          })));
        } else {
          _self.pushTemplate($(this), html);
        }
      }
    });
  };

  _self.pushTemplate = function (elem, html, pager) {
    if (renderView && renderView.length) {
      if (pager && _self.pager && _self.pager.length) if (renderView.find('[data-pager]').length) {
        renderView.find('[data-pager]').html(pager);
      } else if (renderView.closest('[data-target]').find('[data-pager]').length) {
        renderView.closest('[data-target]').find('[data-pager]').html(pager);
      }
    } else {
      if (_self.pager && _self.pager.length && $('[data-pager]').length && pager) $('[data-pager]').html(pager);
    }

    if (replace) {
      elem.html(html);
    } else elem.append(html);

    window.dispatchEvent(handlebarsevent);
  };

  return _self.render();
};

var errorHandler = function errorHandler(data, from, tabs, notlower) {
  var _self = this;

  _self.data = data;
  _self.errorsField = Object.keys(data);
  _self.form = from ? from : $('[data-form]');
  _self.errorElements = [];

  _self.render = function () {
    $.each(_self.errorsField, function (key, val) {
      var label = $('<label>').addClass('error'),
          elem;

      if (notlower) {
        elem = '[name="' + this + '"]';
      } else {
        elem = '[name="' + this.replace(/^(.)/gm, function (s) {
          return s.toLowerCase();
        }) + '"]';
      }

      label.text(_self.data[this]);

      if (_self.form.find(elem).length) {
        _self.form.find(elem).addClass('error error-server');

        _self.form.find(elem).parent().append(label);

        _self.errorElements.push(_self.form.find(elem));
      } else if (_self.form.find('.tab-content.active [data-error-back]')) {
        _self.form.find('.tab-content.active [data-error-back]').removeClass('hide').append(label);

        _self.errorElements.push(_self.form.find('.tab-content.active [data-error-back]'));
      }
    });

    if (tabs && _self.errorElements.length) {
      $('.switchTab[data-target="' + _self.errorElements[0].closest('[data-target]').attr('data-target') + '"]').trigger('click');
      $('html,body').animate({
        scrollTop: _self.errorElements[0].offset().top - 20
      });
    }
  };

  return _self.render();
};

var resetErrorHandler = function resetErrorHandler(form) {
  var _self = this;

  _self.form = form;

  _self.reset = function () {
    var elements = _self.form.find('label.error');

    _self.form.find('.error').removeClass('error');

    elements.remove();

    if (_self.form.find('[data-error-back]').length) {
      _self.form.find('[data-error-back]').addClass('hide');
    }
  };
};

function addEmployee() {
  if ($('[data-form]').valid()) {
    var emplData = {
      SiteId: $("#siteId").val(),
      FirstName: $("#firstName").val(),
      LastName: $("#lastName").val(),
      Email: $("#email").val(),
      Phone: $("#phone").val()
    };
    jQuery.ajax({
      type: "POST",
      url: "/api/sitecore/AffinityPortalAPI/AddNewEmployee",
      headers: {
        'ApiRequest': 'true'
      },
      dataType: "json",
      contentType: 'application/json',
      data: JSON.stringify({
        data: emplData
      }),
      success: function success(data) {
        if (data.IsSuccess) window.location.href = '/edit-site/setup/manage-employees?siteId=' + emplData.SiteId + '&isSuccess=true';else if (data.Errors && Object.keys(data.Errors).length) {
          new errorHandler(data.Errors);
        }
      }
    });
  }
}

function searchEmployees() {
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/SearchEmployeesByName",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      siteId: $("#siteId").val(),
      userInput: $("#userInput").val()
    },
    success: function success(response) {
      if (response.EmployeesList.length) new renderTemplate(response, 'employee-table', true);
    }
  });
}

function searchEmployeeCampaigns() {
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/SearchEmployeesCampaign",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      siteId: $("#siteId").val(),
      userInput: $("#userInput").val()
    },
    success: function success(response) {
      new renderTemplate(response, 'employee-campaign', true, true);
    }
  });
}

function unLinkCampaign(siteId, campaignId, name) {
  jQuery.ajax({
    type: "POST",
    url: "/api/sitecore/AffinityPortalAPI/UnlinkCampaign",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: JSON.stringify({
      siteId: siteId,
      campaignId: campaignId,
      name: name
    }),
    success: function success(response) {}
  });
}

function getReportByDate() {
  var reportType = Number($("#datePeriod").attr('data-selected'));
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/GetReportByDate",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      siteId: $("#siteId").val(),
      reportType: reportType
    },
    success: function success(response) {
      new renderTemplate(response, 'employee-report', true, true);
      $("#reportOptions").hide();
      $("#reportResult").show();
      $("#employee-report-table").show();
      $("#contribution-report-table").hide();
      renderReportHeader(reportType);
    }
  });
}

function getContributionReport() {
  var reportType = Number($("#datePeriod").attr('data-selected'));
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/GetContributionReportByDate",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      siteId: $("#siteId").val(),
      reportType: reportType
    },
    success: function success(response) {
      new renderTemplate(response, 'contribution-report', true, true);
      $("#reportOptions").hide();
      $("#reportResult").show();
      $("#employee-report-table").hide();
      $("#contribution-report-table").show();
      renderReportHeader(reportType);
    }
  });
}

function renderReportHeader(reportType) {
  var objDate = new Date(),
      locale = "en-us",
      month = objDate.toLocaleString(locale, {
    month: "long"
  }),
      year = objDate.getFullYear();

  if (reportType === 1) {
    var dayNow = objDate.getDate(),
        dayWeekAgo = new Date();
    dayWeekAgo.setDate(objDate.getDate() - 6);
    $("#reportingTitle").text("WEEKLY REPORTING VIEW");
    $("#reportingSubTitle").text("Week of " + dayWeekAgo.getDate() + "/" + dayNow);
  } else {
    $("#reportingTitle").text("MONTHLY REPORTING VIEW");
    $("#reportingSubTitle").text(month + " " + year);
  }
}

function backToOptions() {
  $("#reportResult").hide();
  $("#reportOptions").show();
} //todo ajax calls related to add/upd sites


function createNewSite(el) {
  if ($('[data-form]').valid()) {
    var siteData = {
      NameOfOrg: $("#nameOfOrg").val(),
      NameOfAdmin: $("#nameOfAdmin").val(),
      AdminEmail: $("#adminEmail").val(),
      AdminPhone: $("#adminPhone").val(),
      SiteName: validSiteName($("#siteName").val())
    };
    $(el).next('[data-loader]').css('display', 'inline-block');
    $(el).addClass('button--disabled');
    jQuery.ajax({
      type: "POST",
      url: "/api/sitecore/AffinityPortalAPI/CreateNewSite",
      dataType: "json",
      contentType: 'application/json',
      headers: {
        'ApiRequest': 'true'
      },
      data: JSON.stringify({
        data: siteData
      }),
      success: function success(data) {
        $(el).next('[data-loader]').hide();
        $(el).removeClass('button--disabled');
        if (data.IsSuccess) window.location.href = '/sites-list';

        if (data.Errors && Object.keys(data.Errors).length) {
          new errorHandler(data.Errors);
        }
      }
    });
  }
}

function validSiteName(siteName) {
  var validUrl = siteName.replace(/\s/g, "").replace(/[^a-zA-Z0-9-_]/g, "-").replace(/\-+/g, "-");
  return trim(validUrl, "-");
}

function updateSite(_this, e) {
  if (e && e.preventDefault) e.preventDefault();

  if ($(_this).closest('[data-form]').valid()) {
    var updateData = {
      NameOfOrg: $("#nameOfOrg").val(),
      NameOfAdmin: $("#nameOfAdmin").val(),
      AdminEmail: $("#adminEmail").val(),
      AdminPhone: $("#adminPhone").val(),
      PhoneExtension: $("#phoneExtension").val(),
      SiteName: $("#siteName").val(),
      SiteId: $("#siteId").val(),
      Street: $("#street").val(),
      City: $("#city").val(),
      State: $("#state :selected").val(),
      Zip: $("#zip").val(),
      OrganizationId: $('#OrganizationId :selected').val(),
      "LOSettings": {
        "IsWorkWithCMGLo": $("input[name='loanShow']:checked").val(),
        "LOUserId": $("input[name='searchLoane']").attr('data-id')
      }
    };
    jQuery.ajax({
      type: "POST",
      url: "api/sitecore/EditOrg/UpdateSiteData",
      dataType: "json",
      contentType: 'application/json',
      headers: {
        'ApiRequest': 'true'
      },
      data: JSON.stringify({
        data: updateData
      }),
      success: function success(data) {
        if (data.Errors && Object.keys(data.Errors).length) {
          new errorHandler(data.Errors);
        } else {
          var form = $('[data-form]');
          $.each(form.find('[data-default]'), function () {
            $(this).attr('data-default', $(this).val());
          });
          form.find('[data-change-button]').removeClass('button--green').addClass('disabled').addClass('button--silver');
        }
      }
    });
  }
}

function unsubscribe(_this, e) {}

function deActiveSite() {
  var siteId = $("#siteId").val();
  jQuery.ajax({
    type: "POST",
    url: "/api/sitecore/AffinityPortalAPI/DeactiveSite",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: JSON.stringify({
      siteId: siteId
    }),
    success: function success(response) {}
  });
}

function uploadPhoto() {
  preloader(true);
  var siteId = $("#siteId").val();
  var file = document.querySelector('input[type=file]').files[0];
  jQuery.ajax({
    url: '/api/sitecore/AffinityMediaApi/UploadFile',
    type: 'POST',
    headers: {
      'ApiRequest': 'true'
    },
    data: new FormData().append("FileUpload", file).append("siteId", siteId),
    async: true,
    success: function success(response) {
      preloader(false);
      var obj = JSON.parse(response);

      if (obj.IsSuccess) {
        campaignModel.Campaign.CampaignPhotoUrl = obj.Result;
        renderNextStep(campaignModel);
      }
    },
    xhr: function xhr() {
      var myXhr = $.ajaxSettings.xhr();

      if (myXhr.upload) {
        // For handling the progress of the upload
        myXhr.upload.addEventListener('progress', function (e) {
          if (e.lengthComputable) {
            /* $('progress').attr({
            value: e.loaded,
            max: e.total,
            });*/
            jQuery('.preloaderPercent').text(parseInt(e.loaded / e.total * 100) + '%');
          }
        }, false);
        myXhr.upload.addEventListener('load', function (e) {
          jQuery('.preloaderPercent').text('File is saved, please wait...');
        }, false);
      }

      return myXhr;
    },
    cache: false,
    contentType: false,
    processData: false
  }).fail(function (jqXHR, textStatus, errorThrown) {
    console.log('Error: ' + errorThrown);
  });
}

function updateEAHomeData(siteId, scope, _this, data_target, isReloadPage) {
  new resetErrorHandler($(_this).closest('[data-form]'));

  if ($(_this).closest('[data-form]').valid()) {
    var data = {
      Logo: {
        Url: $(_this).closest('.org-admin-page').find('[data-logo-upload] [upload-logo-preview]').val(),
        OriginalUrl: $(_this).closest('.org-admin-page').find('[data-logo-upload]  [upload-logo-original-url]').val(),
        PublicId: $(_this).closest('.org-admin-page').find('[data-logo-upload] [upload-logo-public-id]').val(),
        Preview: $(_this).closest('.org-admin-page').find('[data-logo-upload] [upload-logo-url]').val()
      },
      IsDisplay: $('#spSwitch:checked').length,
      AdminName: $('#nameOfAdmin').val(),
      AdminEmail: $('#adminEmail').val(),
      AdminPhone: $('#adminPhone').val(),
      MatchSetting: $(_this).closest('.org-admin-page').find("input[name='matchsettings']:checked").val(),
      MaxAmount: $(_this).closest('.org-admin-page').find("[name='maxAmount']").val(),
      Donation: $(_this).closest('.org-admin-page').find("input[name='donation']:checked").data('target'),
      SiteId: siteId,
      Scopes: scope
    };
    if ($(_this).closest('.org-admin-page').find("[name='siteId']").length) data.SiteId = $(_this).closest('.org-admin-page').find("[name='siteId']").val();
    if ($(_this).closest('.org-admin-page').find("[name='adminPhone']").length) data.AdminPhone = $(_this).closest('.org-admin-page').find("[name='adminPhone']").val();
    if ($(_this).closest('.org-admin-page').find("[name='adminName']").length) data.AdminName = $(_this).closest('.org-admin-page').find("[name='adminName']").val();
    if ($(_this).closest('.org-admin-page').find("[name='adminEmail']").length) data.AdminEmail = $(_this).closest('.org-admin-page').find("[name='adminEmail']").val();
    if ($(_this).closest('.org-admin-page').find("[name='IsDisplay']").length) data.IsDisplay = $(_this).closest('.org-admin-page').find("[name='IsDisplay']")[0].checked;
    if ($(_this).closest('.org-admin-page').find("[name='SocialTitle']").length) data.SocialTitle = $(_this).closest('.org-admin-page').find("[name='SocialTitle']").val();
    if ($(_this).closest('.org-admin-page').find("[name='SocialMessage']").length) data.SocialMessage = $(_this).closest('.org-admin-page').find("[name='SocialMessage']").val();
    if ($(_this).closest('.org-admin-page').find("[name='SPPreview']").length) if ($(_this).closest('.org-admin-page').find('#spSwitch').is(':checked')) {
      data.SocialImage = {
        Url: $(_this).closest('.org-admin-page').find("[name='SPUrl']").val(),
        OriginalUrl: $(_this).closest('.org-admin-page').find("[name='SPOriginalUrl']").val(),
        PublicId: $(_this).closest('.org-admin-page').find("[name='SPPublicId']").val(),
        Preview: $(_this).closest('.org-admin-page').find("[name='SPPreview']").val()
      };
    } else {
      data.SocialImage = {
        PublicId: $(_this).closest('.org-admin-page').find("[data-cover-radio]:checked").val()
      };
    }

    if ($('div[data-target="profile"]').hasClass('active') && !$('#oldPasswordSetting').hasClass('ignore')) {
      data.Scopes.push($('#oldPasswordSetting').data('scope'));
      data.ChangePassword = {
        OldPassword: $('#oldPasswordSetting').val(),
        NewPassword: $('#newPasswordSetting').val()
      };
    }

    jQuery.ajax({
      type: "POST",
      url: "/api/sitecore/ApSettings/UpdateEAHomeData",
      headers: {
        'ApiRequest': 'true'
      },
      dataType: "json",
      contentType: 'application/json',
      data: JSON.stringify({
        data: data
      }),
      success: function success(response) {
        if (response.IsSuccess === false) {
          new errorHandler(response.Errors, $(_this).closest('[data-form]'));
        } else {
          $('html,body').stop().animate({
            scrollTop: 0
          }, 500, 'swing');

          if (data_target === 'pledgesettings-setup') {
            jQuery('[data-target = "pledgesettings-setup"]').trigger("click");
          }

          if (response.Data.Scopes.indexOf("Logo") != -1 && $('[data-partners-logo]').length && $('[data-partners-logo]').attr('src') != response.Data.Logo.Url) {
            $('[data-partners-logo]').attr('src', response.Data.Logo.Url);
          }

          if (data_target === 'paymentoptions-setup') {
            if (isReloadPage != response.Data.MatchSetting) jQuery('[data-target = "paymentoptions-setup"]').trigger("click");else if (isReloadPage == response.Data.MatchSetting) {
              location.reload();
            } else {
              console.log("IsRelaodPage is not defined");
            }
          }
        }
      }
    });
  }
}

function updateEAHomeDataRP(siteId, scope, _this, data_target, isReloadPage) {
  var reset = new resetErrorHandler($(_this).closest('[data-form]'));
  reset.reset();

  if ($(_this).closest('[data-form]').valid()) {
    $(_this).addClass('button--disabled');
    var form = $(_this).closest('.org-admin-page'),
        url,
        data = {
      "Logo": {
        Url: form.find("[name='Preview']").val(),
        OriginalUrl: form.find("[name='OriginalUrl']").val(),
        PublicId: form.find("[name='PublicId']").val(),
        Preview: form.find("[name='Url']").val()
      },
      "LogoProfile": {
        Url: form.find("[name='ProfilePreview']").val(),
        OriginalUrl: form.find("[name='LogoProfileOriginalUrl']").val(),
        PublicId: form.find("[name='ProfilePublicId']").val(),
        Preview: form.find("[name='ProfileUrl']").val()
      },
      IsDisplay: form.find('#spSwitch:checked').length,
      AdminName: form.find('#nameOfAdmin').val(),
      AdminEmail: form.find('#adminEmail').val(),
      AdminPhone: form.find('#adminPhone').val(),
      MatchSetting: form.find("input[name='matchsettings']:checked").val(),
      MaxAmount: form.find("[name='maxAmount']").val(),
      Donation: form.find("input[name='donation']:checked").data('target'),
      SiteId: siteId,
      Scopes: scope,
      RealtorLicence: form.find("[name='realtorLicence']").val(),
      NameOfOrganization: form.find("[name='nameOfOrganization']").val(),
      RealtorTitle: form.find("[name='realtorTitle']").val(),
      WorkAddress: form.find("[name='workAddress']").val(),
      WorkAddressOpt: form.find("[name='workAddressOpt']").val(),
      City: form.find("[name='city']").val(),
      State: form.find("[name='state']").val(),
      ZipCode: form.find("[name='zipCode']").val(),
      SiteName: form.find("[name='siteName']").val(),
      AboutMe: form.find("[name='aboutMe']").val(),
      Disclaimer: form.find("[name='disclaimer']").val(),
      "LOSettings": {
        "IsWorkWithCMGLo": form.find('[name="loanShow"]:checked').val(),
        "LOUserId": form.find("input[name='searchLoane']").attr('data-id')
      }
    };
    if (form.find("[name='adminPhone']").length) data.AdminPhone = form.find("[name='adminPhone']").val();
    if (form.find("[name='phoneExtension']").length) data.PhoneExtension = form.find("[name='phoneExtension']").val();
    if (form.find("[name='siteId']").length) data.SiteId = form.find("[name='siteId']").val();
    if (form.find("[name='adminName']").length) data.AdminName = form.find("[name='adminName']").val();
    if (form.find("[name='adminEmail']").length) data.AdminEmail = form.find("[name='adminEmail']").val();
    if (form.find("[name='IsDisplay']").length) data.IsDisplay = form.find("[name='IsDisplay']")[0].checked;
    if (form.find("[name='SocialTitle']").length) data.SocialTitle = form.find("[name='SocialTitle']").val();
    if (form.find("[name='SocialTitle']").length) data.SocialTitle = form.find("[name='SocialTitle']").val();
    if (form.find("[name='SocialMessage']").length) data.SocialMessage = form.find("[name='SocialMessage']").val();
    if (form.find("[name='SPPreview']").length) data.SocialImage = {
      Url: form.find("[name='SPUrl']").val(),
      OriginalUrl: form.find("[name='SPOriginalUrl']").val(),
      PublicId: form.find("[name='SPPublicId']").val(),
      Preview: form.find("[name='SPPreview']").val()
    };
    if (form.find("[name='SPPreview']").length) if (form.find('[data-cover-radio]:checked').attr('data-cover-radio-input')) {
      data.SocialImage = {
        Url: form.find("[name='SPUrl']").val(),
        OriginalUrl: form.find("[name='SPOriginalUrl']").val(),
        PublicId: form.find("[name='SPPublicId']").val(),
        Preview: form.find("[name='SPPreview']").val()
      };
    } else {
      data.SocialImage = {
        PublicId: form.find("[data-cover-radio]:checked").val()
      };
    }

    if ($('div[data-target="profile"]').hasClass('active') && !$('#oldPassword').hasClass('ignore')) {
      data.Scopes.push($('#oldPassword').data('scope'));
      data.ChangePassword = {
        OldPassword: $('#oldPassword').val(),
        NewPassword: $('#newPassword').val()
      };
    }

    if (form.attr('data-target') == 'settings') {
      url = '/api/sitecore/RealtorsSettings/UpdateSite';
    } else {
      url = "/api/sitecore/RealtorsSetup/CreateSite";
    }

    jQuery.ajax({
      type: "POST",
      url: url,
      dataType: "json",
      headers: {
        'ApiRequest': 'true'
      },
      contentType: 'application/json',
      data: JSON.stringify({
        data: data
      }),
      success: function success(response) {
        $(_this).removeClass('button--disabled');

        if (response.IsSuccess === false) {
          $("#siteNameChanged").addClass("hidden");
          $("#siteNameChanged").addClass("error");
          new errorHandler(response.Errors, $(_this).closest('.org-admin-page'), true);
        } else {
          $('html,body').stop().animate({
            scrollTop: 0
          }, 500, 'swing');

          if (data_target === 'pledgesettings-setup') {
            jQuery('[data-target = "pledgesettings-setup"]').trigger("click");
          }

          if (response.Data.Scopes.indexOf("Logo") != -1 && $('[data-partners-logo]').length && $('[data-partners-logo]').attr('src') != response.Data.Logo.Url) {
            $('[data-partners-logo]').attr('src', response.Data.Logo.Url);
          }

          if (data_target === 'paymentoptions-setup') {
            if (isReloadPage == 'true' && response.Data.SiteStatus == "Active" && response.Data.HomeUrl.length) {
              $(_this).addClass('button--disabled');
              location.href = response.Data.HomeUrl;
            } else if (isReloadPage != response.Data.MatchSetting) jQuery('[data-target = "paymentoptions-setup"]').trigger("click");else {
              console.log("IsRelaodPage is not defined");
            }
          }

          $('#PublicUrl').val(response.Data.SocialPageUrl);
          $("#socialPageUrlView").attr("href", response.Data.SocialPageUrl);
          $("#siteNameChanged").addClass("hidden");
          $("#siteNameChanged").addClass("error");
          $('#SiteName').attr('data-value', response.Data.SiteName);
          history.pushState({}, null, response.Data.HomeUrl);
        }
      }
    });
  }
}

function getResetPasswordData(siteId, template) {
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/GetResetPasswordData",
    dataType: "json",
    headers: {
      'ApiRequest': 'true'
    },
    contentType: 'application/json',
    data: {
      siteId: siteId
    },
    success: function success(response) {
      if (response) {
        new renderTemplate(response, template, true, true, true);
      }
    }
  });
} //function resetPassword(template,OrgName, siteId) {
//    jQuery.ajax({
//        type: "POST",
//        url: "/api/sitecore/AffinityPortalAPI/ResetPassword",
//        dataType: "json",
//        contentType: 'application/json',
//        data: JSON.stringify({ siteId: siteId, adminEmail: $("#adminEmail").val() }),
//        success: function (response) {
//				if (response.IsSuccess) {
//					new renderTemplate({'OrgName':OrgName}, template, true, true, true);
//				}
//        }
//    });
//}


function renderResetTable(template) {
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/SearchSitesByAll",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      isActive: $("#isActive").val(),
      userInput: ''
    },
    success: function success(response) {
      if (response.IsSuccess) {
        new renderTemplate(response, template, true, true, true);
      }
    }
  });
}

function searchSites(template, variable, variableTemplate) {
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/SearchSitesByAll",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      isActive: $("#isActive").val(),
      userInput: $("#userInput").val()
    },
    success: function success(response) {
      if (response) {
        if (variable == 'reset') {
          new renderTemplate(response, variableTemplate, true, true, true);
        } else {
          new renderTemplate(response, template, true);
        }
      }
    }
  });
}

function superAdminSignIn() {
  jQuery.ajax({
    type: "POST",
    url: "/api/sitecore/AffinityPortalAPI/SuperAdminSignIn",
    dataType: "json",
    contentType: 'application/json',
    data: JSON.stringify({
      adminName: $("#adminName").val(),
      password: $("#password").val()
    }),
    success: function success(response) {
      if (response.IsSuccess) window.location.href = response.RedirectUrl;
    }
  });
}

function searchByEmployerName() {
  jQuery.ajax({
    type: "GET",
    url: "/api/sitecore/AffinityPortalAPI/SearchByEmployerName",
    headers: {
      'ApiRequest': 'true'
    },
    dataType: "json",
    contentType: 'application/json',
    data: {
      userInput: $("#userInput").val()
    },
    success: function success(response) {}
  });
}